/* eslint-disable */
import qs from 'qs';
import forOwn from 'lodash/forOwn';

export default ((history) => {
  /**
   * On history change stack of callbacks to execute depending
   * on the matching history.state and query strings
   * @type {Array}
   * @link See README.md for more details on how to use the history to mount / unmount React components
   * @example
   * [
   *      {name: 'item.views.item', tab: ['details', 'online_details']},
   *      function (filters) { console.log('Entering page!'); },
   *      function (filters) { console.log('Leaving page!'); }
   * ]
   */
  history.onChangeStateStack = [];

  /**
   * Array of function to execute when leaving the current state
   * @type {Array}
   */
  history.onLeaveStateStack = [];

  /**
   * Array of matched state filters corresponding to the current state,
   * will be validated against when trying to call the leaveStack
   * @type {Array}
   */
  history.matchedStateStack = [];

  /**
   * Save the href when the last changeState was called. This will be used
   * to remount a component if the href is the same as the previous one
   * in case of a gui-def save action
   * @type {String}
   */
  history.previousStateChangeHref = '';

  /**
   * Called every time a page changes or when an async call is made.
   * Execute any matching history.state callbacks
   */
  history.changeState = function () {
    // Save to prevent a double changeState from Client.js
    // in case changeState is called before the document is ready
    window.history_changed = true;

    history.clearLeaveStateStack();

    let isValidState;
    let isValidStateAtLeastOnce = false;
    let unchangedRequirements = 0;
    let requirements;

    const filters = history.getFilters();
    const changedStackLength = history.onChangeStateStack.length;
    for (let i = 0; i < changedStackLength; ++i) {
      if (
        !Array.isArray(history.onChangeStateStack[i]) ||
        (isValidState &&
          history.onChangeStateStack[i][1] === history.onChangeStateStack[i - 1]?.[1])
      ) {
        continue;
      }

      if (!history.matchedStateStack[i]) {
        history.matchedStateStack[i] = {};
      }

      isValidState = true;
      unchangedRequirements = 0;

      for (const requirement in history.onChangeStateStack[i][0]) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        requirements = history.onChangeStateStack[i][0][requirement];

        if (Array.isArray(requirements)) {
          for (let x = 0, xx = requirements.length; x < xx; ++x) {
            // @ts-expect-error ts-migrate(7015) FIXME: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
            if (filters[requirement] === requirements[x]) {
              // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
              history.matchedStateStack[i][requirement] = filters[requirement];
              break;
            }
          }
        } else {
          if (
            // @ts-expect-error ts-migrate(7015) FIXME: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
            filters[requirement] &&
            // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            history.matchedStateStack[i][requirement] === filters[requirement]
          ) {
            unchangedRequirements += 1;
            continue;
          }
          // The `undefined` requirement is mainly used by setting an `id: undefined` filter
          // to match a mount / unmount component. When the value is undefined, it will get
          // replaced by the matched filter value. Meaning that if the current page is
          // `item > view > id 14`, the 14 filter value will be placed in the matching mount
          // filter. When navigating to item 15 the id will no longer be matching and the
          // component from id 14 and will be unmounted while the 15 will be mounted, and
          // so on. Setting an `id: undefined` is exclusively required for mounting component
          // inside views where there is a navigation to go to the next entry with matching filters.
          // @ts-expect-error ts-migrate(7015) FIXME: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
          if (requirements === undefined || filters[requirement] === requirements) {
            // @ts-expect-error ts-migrate(7015) FIXME: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
            if (!filters[requirement]) continue;
            // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            history.matchedStateStack[i][requirement] = filters[requirement];
          } else {
            isValidState = false;
            break;
          }
        }
      }

      // Reset the unchanged counter if the previous href is the same as the current one
      if (history.previousStateChangeHref === window.location.href) {
        unchangedRequirements = 0;
      }

      isValidState =
        isValidState &&
        !!(Object.keys(history.matchedStateStack[i]).length - unchangedRequirements);

      if (isValidState) {
        history.onChangeStateStack[i][1](filters);

        if (!history.onLeaveStateStack[i]) {
          history.onLeaveStateStack[i] = history.onChangeStateStack[i][2] || function () {};
        }
        isValidStateAtLeastOnce = true;
      } else if (!Object.keys(history.matchedStateStack[i]).length) {
        delete history.matchedStateStack[i];
      }
    }

    history.previousStateChangeHref = window.location.href;

    return isValidStateAtLeastOnce;
  };

  /**
   * Set the filters from the history.state and the location.search string
   * to compare against when changing the history
   * @returns {Object}
   */
  history.getFilters = function () {
    const filters = history.state || {};

    const parsed = qs.parse(location.search, { ignoreQueryPrefix: true }) || {};

    forOwn(parsed, (value, key) => {
      filters[key] = value || undefined;
    });

    filters.pathname = window.location.pathname;

    return filters;
  };

  /**
   * Execute the "Leave State" stack
   * The callback will be cleared from the queue when true or undefined is returned
   */
  history.clearLeaveStateStack = function () {
    if (!history.onLeaveStateStack.length) return;

    const filters = history.getFilters();
    for (let i = 0, ii = history.onLeaveStateStack.length; i < ii; ++i) {
      if (typeof history.onLeaveStateStack[i] === 'undefined') continue;
      if (!history.matchedStateStack[i]) continue;

      for (const requirement in history.matchedStateStack[i]) {
        // @ts-expect-error ts-migrate(7015) FIXME: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
        if (filters[requirement] !== history.matchedStateStack[i][requirement]) {
          history.onLeaveStateStack[i](filters);
          delete history.onLeaveStateStack[i];
          delete history.matchedStateStack[i];
          break;
        }
      }
    }
  };

  /**
   * Bind changeState callbacks when entering / leaving pages
   * @param {Object|Array} requirements - List of requirements for the event to be fired
   * @param {Function} enterCallback - Executed callback if the requirements are met
   * @param {Function} [leaveCallback] - Executed callback on the next changeState
   * @returns {*} Index of the created event
   */
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(requirements: Partial<{ name: string; tab: ... Remove this comment to see the full error message
  history.onChangeState = function (requirements, enterCallback, leaveCallback) {
    if (Array.isArray(requirements)) {
      for (let i = 0, ii = requirements.length; i < ii; ++i) {
        history.onChangeState(requirements[i], enterCallback, leaveCallback);
      }
      return;
    }
    if (typeof requirements !== 'object' || !Object.keys(requirements).length) return;
    if (typeof enterCallback !== 'function') return;
    if (leaveCallback && typeof leaveCallback !== 'function') return;
    const newStack = [requirements, enterCallback, leaveCallback] as HistoryStack;
    return history.onChangeStateStack.push(newStack) - 1;
  };
})(window.history);
